var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { appEnv } from '../env';
import { TokenType } from '../types/common';
export function getImxAssets(imxClient, tokenType, walletAddress, queue, assets, parsedFilters, orderBy, direction, cursor, remaining, parseCurrencyQuantity, options) {
    return __awaiter(this, void 0, Promise, function () {
        var currentCusor, response, result, ordersResult, _a, tokenIds, data, cardsShredData, _b, cardSupplyData, _c, stakingData, _d, _loop_1, _i, _e, foundAsset;
        var _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    currentCusor = (options === null || options === void 0 ? void 0 : options.refresh) ? undefined : cursor;
                    result = [];
                    return [4 /*yield*/, queue.add(function () {
                            return imxClient.listAssets({
                                collection: appEnv.blockchain.collectionAddress,
                                user: walletAddress,
                                metadata: JSON.stringify(parsedFilters),
                                pageSize: (options === null || options === void 0 ? void 0 : options.pageSize) || 200,
                                orderBy: orderBy,
                                direction: direction,
                                status: 'imx',
                                sellOrders: true,
                                name: options === null || options === void 0 ? void 0 : options.assetName,
                                cursor: currentCusor,
                            });
                        })];
                case 1:
                    response = _m.sent();
                    currentCusor = response.cursor;
                    if (!((options === null || options === void 0 ? void 0 : options.withOrders) && response.result.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, imxClient.listOrders({
                            sellMetadata: JSON.stringify({ tokenId: response.result.map(function (asset) { return asset.token_id; }) }),
                            status: 'active',
                            pageSize: 200,
                        })];
                case 2:
                    _a = _m.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = undefined;
                    _m.label = 4;
                case 4:
                    ordersResult = _a;
                    tokenIds = response.result.map(function (asset) { return Number.parseInt(asset.token_id); });
                    return [4 /*yield*/, gqlSdk.GetNumberingFromTokenIds({ input: { totalTokenIds: tokenIds } })];
                case 5:
                    data = _m.sent();
                    if (!(tokenType === TokenType.CARD)) return [3 /*break*/, 7];
                    return [4 /*yield*/, gqlSdk.MpCardWithDisenchantPreviewFindMany({ input: { tokenIds: tokenIds } })];
                case 6:
                    _b = _m.sent();
                    return [3 /*break*/, 8];
                case 7:
                    _b = undefined;
                    _m.label = 8;
                case 8:
                    cardsShredData = _b;
                    if (!(tokenType === TokenType.CARD)) return [3 /*break*/, 10];
                    return [4 /*yield*/, gqlSdk.MpCardSupplyFindByTokenIds({ input: { tokenIds: tokenIds } })];
                case 9:
                    _c = _m.sent();
                    return [3 /*break*/, 11];
                case 10:
                    _c = undefined;
                    _m.label = 11;
                case 11:
                    cardSupplyData = _c;
                    if (!(options === null || options === void 0 ? void 0 : options.refresh) && assets) {
                        result = __spreadArray([], assets, true);
                    }
                    if (!(tokenType === TokenType.MINT_PASS)) return [3 /*break*/, 13];
                    return [4 /*yield*/, gqlSdk.CtaTokenStakeFindMany()];
                case 12:
                    _d = _m.sent();
                    return [3 /*break*/, 14];
                case 13:
                    _d = undefined;
                    _m.label = 14;
                case 14:
                    stakingData = _d;
                    _loop_1 = function (foundAsset) {
                        var dataIndex = ((_f = data.getNumberingFromTokenIds) === null || _f === void 0 ? void 0 : _f.totalNumbering)
                            ? data.getNumberingFromTokenIds.totalNumbering.findIndex(function (element) { return element.tokenId.toString() === foundAsset.token_id; })
                            : -1;
                        var tokenType_1 = dataIndex !== -1 && ((_g = data.getNumberingFromTokenIds) === null || _g === void 0 ? void 0 : _g.totalNumbering)
                            ? (_h = data.getNumberingFromTokenIds) === null || _h === void 0 ? void 0 : _h.totalNumbering[dataIndex].tokenType
                            : undefined;
                        if (tokenType_1 === 'CARD_SHARD')
                            tokenType_1 = TokenType.SHARD;
                        var price = void 0;
                        var numbering = void 0;
                        var shredPreview = void 0;
                        var orderId = void 0;
                        if (ordersResult && parseCurrencyQuantity) {
                            var foundOrder = ordersResult.result.find(function (order) { return order.sell.data.token_id === foundAsset.token_id; });
                            if (foundOrder) {
                                price = parseCurrencyQuantity(foundOrder.buy.data.quantity_with_fees, foundOrder.buy.data.token_address);
                                orderId = foundOrder.order_id;
                            }
                        }
                        var cardShredData = cardsShredData
                            ? cardsShredData.mpCardWithDisenchantPreviewFindMany.find(function (data) { var _a; return ((_a = data.card.tokenId) === null || _a === void 0 ? void 0 : _a.toString()) === foundAsset.token_id; })
                            : undefined;
                        if (data && dataIndex !== -1 && ((_j = data.getNumberingFromTokenIds) === null || _j === void 0 ? void 0 : _j.totalNumbering)) {
                            numbering = (_k = data.getNumberingFromTokenIds) === null || _k === void 0 ? void 0 : _k.totalNumbering[dataIndex].numbering;
                        }
                        else if (cardShredData) {
                            numbering = cardShredData.card.numbering;
                        }
                        shredPreview = cardShredData
                            ? {
                                stonesCount: cardShredData.disenchantPreview.stoneEternal,
                                triselsCount: cardShredData.disenchantPreview.freeGemsCount,
                            }
                            : undefined;
                        var supply = cardSupplyData
                            ? cardSupplyData.mpCardSupplyFindByTokenIds.cards.find(function (data) { var _a; return ((_a = data.tokenId) === null || _a === void 0 ? void 0 : _a.toString()) === foundAsset.token_id; })
                            : undefined;
                        var staking = stakingData
                            ? stakingData.ctaTokenStakeFindMany.find(function (element) { var _a, _b; return ((_b = (_a = element.mintPass) === null || _a === void 0 ? void 0 : _a.tokenId) === null || _b === void 0 ? void 0 : _b.toString()) === foundAsset.token_id; })
                            : undefined;
                        result.push({
                            asset: foundAsset,
                            orderId: orderId,
                            price: price,
                            numbering: numbering,
                            tokenType: tokenType_1,
                            isPendingBurn: dataIndex === -1 ? undefined : (_l = data.getNumberingFromTokenIds) === null || _l === void 0 ? void 0 : _l.totalNumbering[dataIndex].isPendingBurn,
                            shredPreview: shredPreview,
                            supply: supply === null || supply === void 0 ? void 0 : supply.count,
                            staking: staking,
                        });
                    };
                    for (_i = 0, _e = response.result; _i < _e.length; _i++) {
                        foundAsset = _e[_i];
                        _loop_1(foundAsset);
                    }
                    return [2 /*return*/, {
                            assets: result,
                            cursor: response ? response.cursor : undefined,
                            remaining: response ? response.remaining : remaining,
                        }];
            }
        });
    });
}
